import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideIcons } from "@ng-icons/core";
import { ionChevronBackOutline, ionEyeOutline, ionEyeOffOutline, ionTrashOutline } from "@ng-icons/ionicons";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideToastr } from "ngx-toastr";
import { routes } from "./app.routes";
import { APP_BASE_HREF, registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_BASE_HREF, useValue: "/acesso/" },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideIcons({ ionChevronBackOutline, ionEyeOutline, ionEyeOffOutline, ionTrashOutline }),
    provideAnimations(),
    provideToastr({
      positionClass: "toast-bottom-center",
      preventDuplicates: true,
      closeButton: true,
      timeOut: 3000,
    }),
  ],
};
